import { ValidationBusinessError } from "fieldpro-tools/dist/src/tools/error/error";
import _ from "lodash";
import getErrorMessage from "log/getErrorMessage";
import qs from "qs";
export const shouldRunInBackground = (payload: Object | undefined): boolean => {
  if (payload) {
    return Object.values(payload).some((value) => checkValue(value));
  }
  return false;
};

const checkValue = (value: any): boolean => {
  if (Array.isArray(value)) {
    if (value.length > 500) {
      return true;
    } else {
      if (value.some((e) => checkValue(e))) {
        return true;
      }
    }
  } else if (typeof value === "object" && value !== null) {
    return shouldRunInBackground(value);
  }
  return false;
};

export const prepareQueryWithArrays = (query: any): string => {
  for (const q of Object.keys(query)) {
    if (_.isArray(query[q])) {
      query[q] = `${qs.stringify({ [q]: query[q] }, { arrayFormat: "comma" })}`;
      const queryPrefix = `${q}=`;
      query[q] = `[${query[q]?.substring(queryPrefix?.length ?? 0)}]`;
    }
  }
  const prepareQuery = qs.stringify(query, {
    arrayFormat: "comma",
  });

  return prepareQuery;
};

/**
 * @param error  Error or string
 * @returns the same error when any conditions are respected, or return a new instance of error
 */
export const reComputeError = (error: any) => {
  const errorMessage = getErrorMessage(error);

  if (error.status === 422) {
    return new ValidationBusinessError(errorMessage);
  }

  // "Request aborted" is a client cancel/abort (navigation, superseded fetch),
  // not a server timeout. Leave it as-is so treatErrorNotification can silence
  // it instead of showing a false timeout / network toast (FP-13797).
  error.message = errorMessage;

  return error;
};
